export default class EmailAlreadyConfirmed extends Error {
  name = 'EmailAlreadyConfirmed';

  constructor(readonly message = 'Email Already Confirmed') {
    super(message);
  }
}
